import React, { Fragment } from 'react';
import { Block } from '../../lib/types';
export function BlockRenderer({
  blocks
}: {
  blocks: Block[];
}) {
  return <div className="flex flex-col" data-id="element-365">
      {blocks.map(block => <div key={block.id} className="relative" style={{
      paddingTop: block.settings?.paddingTop === 'large' ? '8rem' : block.settings?.paddingTop === 'medium' ? '4rem' : block.settings?.paddingTop === 'small' ? '2rem' : '0',
      paddingBottom: block.settings?.paddingBottom === 'large' ? '8rem' : block.settings?.paddingBottom === 'medium' ? '4rem' : block.settings?.paddingBottom === 'small' ? '2rem' : '0',
      backgroundColor: block.settings?.backgroundColor && block.settings.backgroundColor !== 'transparent' ? block.settings.backgroundColor : 'transparent'
    }} data-id="element-366">
          <div className={`mx-auto px-6 md:px-12 ${block.settings?.maxWidth === 'full' ? 'max-w-full px-0' : block.settings?.maxWidth === 'narrow' ? 'max-w-3xl' : 'max-w-6xl'}`} data-id="element-367">
            <BlockContent block={block} data-id="element-368" />
          </div>
        </div>)}
    </div>;
}
function BlockContent({
  block
}: {
  block: Block;
}) {
  const {
    type,
    content
  } = block;
  switch (type) {
    case 'hero':
      return <div className={`relative py-20 min-h-[60vh] flex flex-col justify-center ${content.alignment === 'center' ? 'text-center items-center' : content.alignment === 'right' ? 'text-right items-end' : 'text-left items-start'}`} data-id="element-369">
          {content.backgroundImage && <div className="absolute inset-0 z-[-1] overflow-hidden" data-id="element-370">
              <img src={content.backgroundImage} alt="" className="w-full h-full object-cover" data-id="element-371" />
              <div className="absolute inset-0 bg-background" style={{
            opacity: (content.overlayOpacity || 50) / 100
          }} data-id="element-372" />
            </div>}
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl font-bold mb-6 tracking-tighter" data-id="element-373">
            {content.title}
          </h1>
          {content.subtitle && <p className="font-mono text-xl md:text-2xl text-muted-foreground mb-10 max-w-3xl" data-id="element-374">
              {content.subtitle}
            </p>}
          {content.ctaText && <div data-id="element-375">
              <a href={content.ctaLink} className="inline-block bg-primary text-primary-foreground font-mono text-xs uppercase tracking-widest px-8 py-4 hover:bg-primary/90 transition-colors border border-primary" data-id="element-376">
                {content.ctaText}
              </a>
            </div>}
        </div>;
    case 'rich-text':
      return <div className="prose prose-invert max-w-none font-mono text-sm md:text-base leading-relaxed prose-headings:font-display prose-headings:font-bold prose-a:text-primary prose-a:no-underline hover:prose-a:underline" dangerouslySetInnerHTML={{
        __html: content.html
      }} data-id="element-377" />;
    case 'image':
      return <figure className="m-0" data-id="element-378">
          <img src={content.url} alt={content.alt} className={`w-full border border-border ${content.aspectRatio === '16:9' ? 'aspect-video' : content.aspectRatio === '4:3' ? 'aspect-[4/3]' : content.aspectRatio === '1:1' ? 'aspect-square' : content.aspectRatio === '3:2' ? 'aspect-[3/2]' : ''}`} style={{
          objectFit: content.objectFit || 'cover',
          objectPosition: content.objectPosition || 'center'
        }} data-id="element-379" />
          {content.caption && <figcaption className="mt-4 font-mono text-xs text-muted-foreground text-center" data-id="element-380">
              {content.caption}
            </figcaption>}
        </figure>;
    case 'embed':
      return <div className={`w-full border border-border bg-card overflow-hidden ${content.aspectRatio === '16:9' ? 'aspect-video' : content.aspectRatio === '4:3' ? 'aspect-[4/3]' : content.aspectRatio === '1:1' ? 'aspect-square' : ''}`} data-id="element-381">
          {content.html ? <div className="w-full h-full" dangerouslySetInnerHTML={{
          __html: content.html
        }} data-id="element-382" /> : content.url ? <iframe src={content.url} className="w-full h-full border-0" allowFullScreen sandbox="allow-scripts allow-same-origin allow-popups allow-forms" data-id="element-383" /> : <div className="w-full h-full flex items-center justify-center p-8 text-center bg-secondary/30" data-id="element-384">
              <p className="font-mono text-sm text-muted-foreground" data-id="element-385">
                No embed source provided
              </p>
            </div>}
        </div>;
    case 'gallery':
      {
        const cols = content.columns === '1' ? 'grid-cols-1' : content.columns === '2' ? 'grid-cols-1 md:grid-cols-2' : content.columns === '4' ? 'grid-cols-2 md:grid-cols-4' : 'grid-cols-1 md:grid-cols-3';
        const gap = content.gap === 'small' ? 'gap-4' : content.gap === 'large' ? 'gap-12' : 'gap-8';
        return <div className={`grid ${cols} ${gap}`} data-id="element-386">
          {content.images?.map((img: any, i: number) => <figure key={i} className="m-0" data-id="element-387">
              <img src={img.url} alt={img.alt} className="w-full aspect-square border border-border" style={{
              objectFit: 'cover',
              objectPosition: img.objectPosition || 'center'
            }} data-id="element-388" />
              {img.caption && <figcaption className="mt-2 font-mono text-xs text-muted-foreground" data-id="element-389">
                  {img.caption}
                </figcaption>}
            </figure>)}
        </div>;
      }
    case 'video':
      {
        const getEmbedUrl = (url: string) => {
          if (url.includes('youtube.com') || url.includes('youtu.be')) {
            const id = url.includes('youtu.be') ? url.split('/').pop() : new URLSearchParams(new URL(url).search).get('v');
            return `https://www.youtube.com/embed/${id}${content.autoplay ? '?autoplay=1' : ''}${content.loop ? '&loop=1' : ''}`;
          }
          if (url.includes('vimeo.com')) {
            const id = url.split('/').pop();
            return `https://player.vimeo.com/video/${id}${content.autoplay ? '?autoplay=1' : ''}${content.loop ? '&loop=1' : ''}`;
          }
          return url;
        };
        const aspectClass = content.aspectRatio === '4:3' ? 'aspect-[4/3]' : content.aspectRatio === '21:9' ? 'aspect-[21/9]' : 'aspect-video';
        if (content.embedCode) {
          return <div className={`w-full ${aspectClass} border border-border overflow-hidden`} dangerouslySetInnerHTML={{
            __html: content.embedCode
          }} data-id="element-390" />;
        }
        return <div className={`w-full ${aspectClass} border border-border overflow-hidden bg-card`} data-id="element-391">
          {content.url ? content.url.includes('youtube') || content.url.includes('youtu.be') || content.url.includes('vimeo') ? <iframe src={getEmbedUrl(content.url)} className="w-full h-full" allow="autoplay; fullscreen" allowFullScreen data-id="element-392" /> : <video src={content.url} className="w-full h-full object-cover" autoPlay={content.autoplay} loop={content.loop} controls data-id="element-393" /> : <div className="w-full h-full flex items-center justify-center font-mono text-xs text-muted-foreground" data-id="element-394">
              No video URL set
            </div>}
        </div>;
      }
    case 'two-column':
      {
        const ratioClass = content.ratio === '60-40' ? 'md:grid-cols-[3fr_2fr]' : content.ratio === '40-60' ? 'md:grid-cols-[2fr_3fr]' : 'md:grid-cols-2';
        return <div className={`grid grid-cols-1 ${ratioClass} gap-12 items-center`} data-id="element-395">
          <div className={`prose prose-invert max-w-none font-mono text-sm leading-relaxed prose-headings:font-display prose-headings:font-bold ${content.reverseMobile ? 'order-2 md:order-1' : ''}`} dangerouslySetInnerHTML={{
            __html: content.leftContent
          }} data-id="element-396" />
          <div className={content.reverseMobile ? 'order-1 md:order-2' : ''} data-id="element-397">
            {content.imageUrl && <img src={content.imageUrl} alt={content.imageAlt} className="w-full border border-border" data-id="element-398" />}
          </div>
        </div>;
      }
    case 'metrics':
      {
        const mCols = content.columns === '2' ? 'grid-cols-1 md:grid-cols-2' : content.columns === '4' ? 'grid-cols-2 md:grid-cols-4' : 'grid-cols-1 md:grid-cols-3';
        return <div className={`grid ${mCols} gap-8`} data-id="element-399">
          {content.metrics?.map((m: any, i: number) => <div key={i} className="border-l-2 border-primary pl-6 py-2" data-id="element-400">
              <div className="font-display text-4xl md:text-5xl font-bold text-foreground mb-2" data-id="element-401">
                {m.value}
              </div>
              <div className="font-mono text-sm font-bold uppercase tracking-widest text-primary mb-2" data-id="element-402">
                {m.label}
              </div>
              {m.description && <div className="font-mono text-xs text-muted-foreground" data-id="element-403">
                  {m.description}
                </div>}
            </div>)}
        </div>;
      }
    case 'testimonial':
      return <div className={`border border-border p-8 md:p-16 ${content.variant === 'large' ? 'bg-primary/5' : 'bg-card'}`} data-id="element-404">
          <blockquote className="m-0" data-id="element-405">
            <p className={`font-display font-medium leading-snug tracking-tight mb-8 ${content.variant === 'large' ? 'text-3xl md:text-5xl' : 'text-xl md:text-2xl'}`} data-id="element-406">
              &ldquo;{content.quote}&rdquo;
            </p>
            <footer className="flex items-center gap-4" data-id="element-407">
              {content.authorImage && <img src={content.authorImage} alt={content.authorName} className="w-12 h-12 rounded-full object-cover grayscale" data-id="element-408" />}
              <div data-id="element-409">
                <div className="font-mono text-sm font-bold text-foreground" data-id="element-410">
                  {content.authorName}
                </div>
                <div className="font-mono text-xs text-muted-foreground uppercase tracking-widest mt-1" data-id="element-411">
                  {content.authorRole}
                </div>
              </div>
            </footer>
          </blockquote>
        </div>;
    case 'timeline':
      return <div className="space-y-12" data-id="element-412">
          {content.steps?.map((step: any, i: number) => <div key={i} className="grid grid-cols-1 md:grid-cols-[1fr_3fr] gap-4 md:gap-12 border-t border-border pt-8" data-id="element-413">
              <div className="font-mono text-sm font-bold text-primary uppercase tracking-widest" data-id="element-414">
                {step.label}
              </div>
              <div data-id="element-415">
                <h3 className="font-display text-2xl font-bold mb-4" data-id="element-416">
                  {step.title}
                </h3>
                <p className="font-mono text-sm text-muted-foreground leading-relaxed" data-id="element-417">
                  {step.description}
                </p>
              </div>
            </div>)}
        </div>;
    case 'divider':
      if (content.type === 'space') return <div className="w-full" data-id="element-418" />;
      if (content.type === 'dots') return <div className="w-full flex justify-center gap-4 text-muted-foreground" data-id="element-419">
            <span data-id="element-420">·</span>
            <span data-id="element-421">·</span>
            <span data-id="element-422">·</span>
          </div>;
      return <div className="w-full h-px bg-border" data-id="element-423" />;
    case 'cta':
      return <div className={`text-center ${content.variant === 'card' ? 'border border-border bg-card p-12 md:p-24' : content.variant === 'full-width' ? 'bg-primary/5 p-12 md:p-24' : ''}`} data-id="element-424">
          <h2 className="font-display text-4xl md:text-6xl font-bold mb-6" data-id="element-425">
            {content.heading}
          </h2>
          {content.description && <p className="font-mono text-base text-muted-foreground mb-10 max-w-2xl mx-auto" data-id="element-426">
              {content.description}
            </p>}
          {content.buttonText && <a href={content.buttonLink} className="inline-block bg-primary text-primary-foreground font-mono text-xs uppercase tracking-widest px-8 py-4 hover:bg-primary/90 transition-colors" data-id="element-427">
              {content.buttonText}
            </a>}
        </div>;
    case 'feature-highlights':
      {
        const fCols = content.columns === '2' ? 'grid-cols-1 md:grid-cols-2' : content.columns === '4' ? 'grid-cols-2 md:grid-cols-4' : 'grid-cols-1 md:grid-cols-3';
        return <div className={`grid ${fCols} gap-12`} data-id="element-428">
          {content.features?.map((f: any, i: number) => <div key={i} data-id="element-429">
              <div className="w-12 h-12 border border-border flex items-center justify-center text-primary mb-6 bg-card font-mono text-xs" data-id="element-430">
                {f.icon || '★'}
              </div>
              <h3 className="font-display text-xl font-bold mb-3" data-id="element-431">{f.title}</h3>
              <p className="font-mono text-sm text-muted-foreground leading-relaxed" data-id="element-432">
                {f.description}
              </p>
            </div>)}
        </div>;
      }
    case 'before-after':
      {
        const isStacked = content.layout === 'stacked';
        return <div className={`grid ${isStacked ? 'grid-cols-1 gap-8' : 'grid-cols-1 md:grid-cols-2 gap-8'}`} data-id="element-433">
          <div data-id="element-434">
            <div className="font-mono text-xs uppercase tracking-widest text-muted-foreground mb-3" data-id="element-435">
              {content.beforeLabel || 'Before'}
            </div>
            {content.beforeImage && <img src={content.beforeImage} alt={content.beforeLabel || 'Before'} className="w-full border border-border" data-id="element-436" />}
          </div>
          <div data-id="element-437">
            <div className="font-mono text-xs uppercase tracking-widest text-primary mb-3" data-id="element-438">
              {content.afterLabel || 'After'}
            </div>
            {content.afterImage && <img src={content.afterImage} alt={content.afterLabel || 'After'} className="w-full border border-border" data-id="element-439" />}
          </div>
        </div>;
      }
    case 'design-system':
    case 'wireframes':
    case 'mockups':
      {
        const dCols = content.columns === '2' || content.layout === 'masonry' ? 'grid-cols-1 md:grid-cols-2' : 'grid-cols-1 md:grid-cols-3';
        return <div data-id="element-440">
          {content.title && <h2 className="font-display text-3xl md:text-4xl font-bold mb-4" data-id="element-441">
              {content.title}
            </h2>}
          {content.description && <p className="font-mono text-sm text-muted-foreground leading-relaxed mb-8 max-w-3xl" data-id="element-442">
              {content.description}
            </p>}
          <div className={`grid ${dCols} gap-8`} data-id="element-443">
            {content.images?.map((img: any, i: number) => <figure key={i} className="m-0" data-id="element-444">
                <img src={img.url || img} alt={img.caption || `Image ${i + 1}`} className="w-full border border-border" data-id="element-445" />
                {img.caption && <figcaption className="mt-2 font-mono text-xs text-muted-foreground" data-id="element-446">
                    {img.caption}
                  </figcaption>}
              </figure>)}
          </div>
        </div>;
      }
    case 'research':
      {
        return <div className="space-y-8" data-id="element-447">
          {content.insights?.map((insight: any, i: number) => <div key={i} className="border-l-2 border-primary pl-6 py-2" data-id="element-448">
              <h3 className="font-display text-xl font-bold mb-2" data-id="element-449">
                {insight.title}
              </h3>
              <p className="font-mono text-sm text-muted-foreground leading-relaxed mb-2" data-id="element-450">
                {insight.finding}
              </p>
              {insight.source && <span className="font-mono text-xs text-primary uppercase tracking-widest" data-id="element-451">
                  Source: {insight.source}
                </span>}
            </div>)}
        </div>;
      }
    case 'competitor':
      {
        return <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-452">
          {content.competitors?.map((c: any, i: number) => <div key={i} className="border border-border bg-card p-6" data-id="element-453">
              <div className="flex items-center gap-4 mb-4" data-id="element-454">
                {c.imageUrl && <img src={c.imageUrl} alt={c.name} className="w-10 h-10 object-contain" data-id="element-455" />}
                <h3 className="font-display text-lg font-bold" data-id="element-456">{c.name}</h3>
              </div>
              <div className="space-y-3" data-id="element-457">
                <div data-id="element-458">
                  <div className="font-mono text-xs text-primary uppercase tracking-widest mb-1" data-id="element-459">
                    Strengths
                  </div>
                  <p className="font-mono text-sm text-muted-foreground" data-id="element-460">
                    {c.strengths}
                  </p>
                </div>
                <div data-id="element-461">
                  <div className="font-mono text-xs text-destructive uppercase tracking-widest mb-1" data-id="element-462">
                    Weaknesses
                  </div>
                  <p className="font-mono text-sm text-muted-foreground" data-id="element-463">
                    {c.weaknesses}
                  </p>
                </div>
              </div>
            </div>)}
        </div>;
      }
    case 'user-flow':
      {
        return <div data-id="element-464">
          {content.title && <h2 className="font-display text-3xl md:text-4xl font-bold mb-4" data-id="element-465">
              {content.title}
            </h2>}
          {content.description && <p className="font-mono text-sm text-muted-foreground leading-relaxed mb-8 max-w-3xl" data-id="element-466">
              {content.description}
            </p>}
          {content.imageUrl && <img src={content.imageUrl} alt={content.title || 'User flow'} className="w-full border border-border mb-8" data-id="element-467" />}
          {content.steps?.length > 0 && <div className="flex flex-wrap gap-3 items-center" data-id="element-468">
              {content.steps.map((step: any, i: number) => <Fragment key={i} data-id="element-469">
                  <div className="px-4 py-2 border border-border bg-card font-mono text-xs uppercase tracking-widest" data-id="element-470">
                    {step.label || step}
                  </div>
                  {i < content.steps.length - 1 && <div className="text-muted-foreground font-mono" data-id="element-471">→</div>}
                </Fragment>)}
            </div>}
        </div>;
      }
    default:
      return <div className="p-8 border border-dashed border-border bg-card text-center" data-id="element-472">
          <p className="font-mono text-xs text-muted-foreground uppercase tracking-widest" data-id="element-473">
            [{type} block]
          </p>
        </div>;
  }
}